/** @format */

// 开票服务商字典项枚举,03：票易通
export enum DictServiceType {
  pyt = '03'
}

export const dictServiceTypeMap: {
  [key: string]: string;
} = {
  [DictServiceType.pyt]: '票易通'
};

// 开票项目字典项枚举,00：临停费
export enum MakeInvoiceType {
  stopFee = '00'
}

export const makeInvoiceTypeMap: {
  [key: string]: string;
} = {
  [MakeInvoiceType.stopFee]: '临停费'
};

// 用户账号状态 0 正常 1停用
export enum DictUserStatus {
  ON = '0',
  OFF = '1'
}

export const DictUserStatusMap: {
  [key: string]: string;
} = {
  [DictUserStatus.ON]: '启用',
  [DictUserStatus.OFF]: '禁用'
};

// 用户状态 0 正常 1停用
export enum deusermode {
  ON = '0',
  OFF = '1'
}

export const deusermodeMap: {
  [key: string]: string;
} = {
  [deusermode.ON]: '启用',
  [deusermode.OFF]: '禁用'
};
